import { render, staticRenderFns } from "./ManageClient.vue?vue&type=template&id=3722d103&"
import script from "./ManageClient.vue?vue&type=script&lang=js&"
export * from "./ManageClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports